/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Redacted_TooltipInputs */



/**
* | output |
* | --- |
* | "This information has been redacted and has not been sent to the LLM." |
*
* @param {Chat_Redacted_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_redacted_tooltip = /** @type {((inputs?: Chat_Redacted_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Redacted_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese Information wurde geschwärzt und wurde nicht an das LLM gesendet.")
	return /** @type {LocalizedString} */ ("This information has been redacted and has not been sent to the LLM.")
});